import React from 'react'

// Components
import Modal from 'app/views/components/UIkit/Modal'
import { Button } from '@hackedu/react-components'

const ModalSendReminders = () => (
  <Modal
    id="modal-info-send-reminders"
    title="Send Reminders"
    body={(
      <div>
        <p>
          If this option is checked, HackEDU will send email reminders to
          anyone in the organization.
          Reminders are sent on every monday at 8am PST and you can pick from
          weekly, biweekly or monthly options.
        </p>
        <p>
          Individuals can opt-out of these emails from their accounts.
        </p>
        <p className="uk-text-right">
          <Button
            content="Ok"
            primary
            extraClassName="uk-modal-close"
          />
        </p>
        <button
          className="uk-modal-close-outside"
          data-uk-close
          type="button"
        />
      </div>
    )}
  />
)

export default ModalSendReminders
